import { useState } from "react";
import { useAuth } from "../lib/auth";
import { formatError } from "../lib/api";
import { Link } from "react-router-dom";

export default function LoginPage() {
  const { login } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(identifier.trim().toLowerCase(), password);
      window.location.href = "/";
    } catch (err) {
      setError(formatError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen w-full flex" data-testid="login-page">
      {/* Left: hero */}
      <div className="hidden lg:block flex-1 relative overflow-hidden" style={{ background: "#0A1628" }}>
        <div
          className="absolute inset-0 bg-center bg-contain bg-no-repeat opacity-30"
          style={{ backgroundImage: "url(/dbs-logo.jpeg)" }}
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(120deg, rgba(10,22,40,0.6) 0%, rgba(9,10,11,0.85) 60%, rgba(9,10,11,1) 100%)" }} />
        <div className="relative h-full flex flex-col justify-between p-12 z-10">
          <div className="flex items-center gap-3">
            <img src="/dbs-logo.jpeg" alt="DBS FIELD" className="w-14 h-14 object-cover" style={{ borderRadius: 2 }} />
            <div>
              <div className="label-caps" style={{ letterSpacing: "0.2em" }}>DBS FIELD</div>
              <div className="text-xs" style={{ color: "var(--text-mute)" }}>Gestão Integrada de Campo</div>
            </div>
          </div>
          <div>
            <h1 className="text-5xl font-black leading-tight max-w-xl" style={{ fontFamily: "Chivo" }}>
              Operações de campo,<br/>
              <span style={{ color: "var(--primary)" }}>sob controle total.</span>
            </h1>
            <p className="mt-6 max-w-md" style={{ color: "var(--text-dim)" }}>
              Ordens de trabalho, estoque de técnicos, frota, ferramentas e produção — tudo em uma plataforma robusta pensada para operações em campo.
            </p>
          </div>
          <div className="label-caps">v1.0 · Ambiente de produção</div>
        </div>
      </div>

      <div className="w-full lg:w-[480px] flex items-center justify-center p-6 md:p-8" style={{ background: "var(--surface)" }}>
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden mb-8 flex items-center gap-3">
            <img src="/dbs-logo.jpeg" alt="DBS FIELD" className="w-10 h-10 object-cover" style={{ borderRadius: 2 }} />
            <div className="label-caps" style={{ letterSpacing: "0.2em" }}>DBS FIELD</div>
          </div>
          <div className="label-caps mb-2">Acesso restrito</div>
          <h2 className="text-3xl font-bold mb-8" style={{ fontFamily: "Chivo" }}>Entrar na plataforma</h2>

          {error && (
            <div className="mb-4 px-3 py-2 text-sm border" style={{ background: "rgba(239,68,68,0.08)", borderColor: "rgba(239,68,68,0.3)", color: "#FCA5A5" }} data-testid="login-error">
              {error}
            </div>
          )}

          <label className="label-caps block mb-1.5">Email ou nome de usuário</label>
          <input
            data-testid="login-identifier"
            className="input mb-4"
            type="text"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="seu email ou usuário"
            required
            autoFocus
          />
          <label className="label-caps block mb-1.5">Senha</label>
          <input
            data-testid="login-password"
            className="input mb-3"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />
          <div className="text-right mb-5">
            <Link to="/forgot-password" className="text-xs" style={{ color: "var(--primary)" }} data-testid="forgot-password-link">
              Esqueci minha senha
            </Link>
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            className="btn btn-primary w-full"
            disabled={loading}
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
